import { apiClient } from '../api.client';
import type { Notification } from '../../types/course';
import type { INotificationService } from '../interfaces/INotificationService';

export const notificationReal: INotificationService = {
  getAll: () => apiClient.get<Notification[]>('/notifications'),
  markRead: (id) => apiClient.patch<void>(`/notifications/${id}/read`, {}),
  markAllRead: () => apiClient.post<void>('/notifications/read-all', {}),
  deleteOne: (id) => apiClient.delete<void>(`/notifications/${id}`),
  clearAll: () => apiClient.delete<void>('/notifications'),
};
